// src/components/ImageModal.jsx
import React from 'react';
import { X } from 'lucide-react';

export default function ImageModal({ imageUrl, onClose }) {
  // Se não houver imageUrl, o modal não é renderizado.
  if (!imageUrl) {
    return null;
  }

  return (
    // Fundo escurecido (overlay) que também fecha o modal ao ser clicado
    <div 
      className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50"
      onClick={onClose}
    >
      {/* Botão de fechar no canto superior direito */}
      <button 
        className="absolute top-4 right-4 text-white p-2 bg-black bg-opacity-50 rounded-full hover:bg-opacity-75"
        onClick={onClose}
      >
        <X size={24} />
      </button>

      {/* Container da imagem para controle de tamanho e para evitar que o clique na imagem feche o modal */}
      <div 
        className="relative p-4" 
        onClick={(e) => e.stopPropagation()} // Impede que o clique se propague para o overlay
      >
        <img 
          src={imageUrl} 
          alt="Visualização em tela cheia" 
          className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
        />
      </div>
    </div>
  );
}